import Big from '../libs/big.min';

const initBig = Big => {
    if (process.env.IS_WEB) {
        window.Big = Big;
    } else {
        global.Big = Big;
    }
};

initBig(Big);


// WEBPACK FOOTER //
// ./~/pluton-core/lib/utils/init3rdParties.js